import { ClientPaymentDto } from '../../../../generated-api'
import { formatCurrencyAndAmount } from '../../../utils/stringUtils'

export const RefundedAmountCard = ({ payment }: { payment: ClientPaymentDto }) => {
    const { refundedAmount, pendingRefundAmount, currency, refundedAndPendingRefundAmount } = payment

    return (
        <div
            className={`flex-col flex-1 rounded-lg p-4 shadow-lg ${
                refundedAndPendingRefundAmount > 0 ? 'bg-purple-lightest' : 'bg-grey-lightest'
            }`}
        >
            <h3 className="text-lg">Refunded amount</h3>
            <p className="font-moret">{formatCurrencyAndAmount(currency, refundedAndPendingRefundAmount)}</p>

            {refundedAndPendingRefundAmount > 0 && (
                <>
                    <div className="flex justify-between mt-1">
                        <h3 className="text-base">Pending refund</h3>
                        <span>{formatCurrencyAndAmount(currency, pendingRefundAmount)}</span>
                    </div>
                    <div className="flex justify-between">
                        <h3 className="text-base">Completed refund</h3>
                        <span>{formatCurrencyAndAmount(currency, refundedAmount)}</span>
                    </div>
                </>
            )}
        </div>
    )
}
